<ng-container>
  <div class="row funding-header" [ngClass]="{'fully-approved-status' : funding.projectInstallmentFundingStatus?.name?.toLowerCase() === 'fully approved'}">
    <div class="col-2">
      {{ fundingTitle }}
    </div>
    <div class="col-2">
      Funding Amount
    </div>
    <div class="col-2">
      Total Adjusters
    </div>
    <div class="col-2">
      Status
    </div>
    <div class="col-4">
      <div class="row date-action">
        <div class="col-md-11">Date</div>
        <div class="col-md-1">
          <div class="row button-flex-end">
            <div class="dropdown-container">
              <div class="dropdown-button" (click)="expandPanel()"><i class="material-icons">{{isExpanded ? 'arrow_drop_up' : 'arrow_drop_down'}}</i></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col funding-container">
    @if (!readOnly) {
      <form [formGroup]="fundingForm">
        <div class="row funding-info">
          <div class="col-2"></div>
          <div class="col-2">
            <span>$</span>
            <input class="shrink-input" [ngClass]="{'red-highlight' : !equityService.checkPaymentTotals(payments, funding)}" currencyParser formControlName="funding_amount" name="funding_amount" type="text" step="1">
          </div>
          <div class="col-2">
            <ng-container>
              <span>$</span>
              <input class="shrink-input" [ngClass]="{'red-highlight' : !equityService.checkPaymentTotals(payments, funding, true)}" currencyParser formControlName="total_adjusters" name="total_adjusters" type="text" step="1">
            </ng-container>
          </div>
          <div class="col-2">
            @if (checkPermissions($safeNavigationMigration(permissions?.fundingPermissions), 'funding_status_id')) {
              <select formControlName="status">
                <option [value]="null">--</option>
                @for (status of fundingStatuses; track status) {
                  <option [value]="status.id">{{status.name}}</option>
                }
              </select>
            }
            @if (!checkPermissions($safeNavigationMigration(permissions?.fundingPermissions), 'funding_status_id')) {
              {{funding.projectInstallmentFundingStatus ? funding.projectInstallmentFundingStatus.name : '--'}}
            }
          </div>
          <div class="col-4">
            <div class="row date-actions">
              <div class="col-md-9">
                <input type="date" formControlName="date" name="date" [readonly]="!checkPermissions($safeNavigationMigration(permissions?.fundingPermissions), 'funding_date')">
              </div>
              <div class="col-md-3">
                <div class="row" style="justify-content: flex-end">
                  <div class="col-md-6">
                    <div class="action-icon" matTooltip="Open Installments Report" (click)="embeddableReportService.popupReport($event, 'Equity Installments', {funding_id:funding.id})"><i class="material-icons">bar_chart</i></div>
                  </div>
                  <!--                <div class="col-md-6">-->
                  <!--&lt;!&ndash;                  <div class="action-icon" matTooltip="Save Funding" *ngIf="permissions?.fundingPermissions?._edit" (click)="saveFunding()"><i class="material-icons save">save</i></div>&ndash;&gt;-->
                <!--                </div>-->
                <div class="col-md-6">
                  @if (permissions?.fundingPermissions?._delete) {
                    <div class="action-icon" matTooltip="Delete Funding" (click)="openRemoveFundingModal()"><i class="material-icons delete">delete</i></div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  }
  @if (readOnly) {
    <div class="row funding-info">
      <div class="col-2"></div>
      <div class="col-2">
        @if (fundingForm.controls['funding_amount'].value!== null) {
          {{fundingForm.controls['funding_amount'].value | currency: 'USD': 'symbol': '1.2-2'}}
        }
        @if (fundingForm.controls['funding_amount'].value == null) {
          --
        }
      </div>
      <div class="col-2">
        @if (fundingForm.controls['total_adjusters'].value !== null) {
          {{ fundingForm.controls['total_adjusters'].value | currency: 'USD' : 'symbol' : '1.2-2' }}
        }
        @if (fundingForm.controls['total_adjusters'].value == null) {
          --
        }
      </div>
      <div class="col-2">
        {{readOnlyStatus ?? '--'}}
      </div>
      <div class="col-4">
        {{fundingForm.controls['date'].value ?? '--'}}
      </div>
    </div>
  }
</div>
<div class="content-container">
  <div class="row generate-row align-top">
    <div class="col-md-2">
      @if (permissions?.packagePermissions?._create) {
        <button class="generate-package-button"
          (click)="generatePackage(funding.id)"
          [ngClass]="{'disabled': funding.projectInstallmentFundingPayments.length == 0}"
          matTooltip="Payments must be generated."
          matTooltipPosition="above"
          [matTooltipDisabled]="funding.projectInstallmentFundingPayments.length !== 0"
          #packageTooltip="matTooltip"
          matTooltipClass="package-tooltip"
        >Generate Package</button>
      }
    </div>
    <div class="col-md-10">
      <div class="row package-header">
        <div class="col-md-2">
          Valid Files
        </div>
        <div class="col-md-2">
          Outlet
        </div>
        <div class="col-md-2">
          Status
        </div>
        <div class="col-md-2">
          Last Updated
        </div>
        <div class="col-md-4">
          <div class="row">
            <div style="max-width: 90%; min-width: 90%;">Link</div>
            <div style="max-width:10%; min-width: 10%;">
              <div class="package-refresh-button" matTooltip="Refresh package list" (click)="refreshPackageList()"><i class="material-icons" style="font-size: 16px">refresh</i></div>
            </div>
          </div>
        </div>
      </div>
      @if (packages.length == 0) {
        <div class="row" style="font-size: 12px">
          <div class="col-md-2">
            <ng-container>{{this.files - this.invalidFiles}}/{{this.files}}</ng-container>
          </div>
          <div class="col-md-8">
            <div class="row" style="justify-content: center">
              No Packages
            </div>
          </div>
        </div>
      }
      @if (packages.length>0) {
        <div>
          @for (pkg of packages; track pkg; let i = $index) {
            <div class="row package-row">
              <div class="col-md-2">
                @if (i==0 && (this.files - this.invalidFiles) == this.files) {
                  {{(this.files - this.invalidFiles) >= 0 ? this.files - this.invalidFiles : 0}}/{{this.files}}
                }
                @if (i==0 && (this.files - this.invalidFiles) !== this.files) {
                  <ng-container style="color: red">{{(this.files - this.invalidFiles) >= 0 ? this.files - this.invalidFiles : 0}}/{{this.files}}</ng-container>
                }
              </div>
              <div class="col-md-2">
                {{ pkg.fund?.name ?? pkg.certificatedOutlet?.organization?.name ?? '--'}}
              </div>
              <div class="col-md-2">
                {{pkg.status}}
              </div>
              <div class="col-md-2">
                {{pkg.modified}}
              </div>
              <div class="col-md-4">
                <div class="row">
                  <div style="max-width: 90%; min-width: 90%">
                    @if (pkg.fileurl!==null) {
                      <a href="{{pkg.fileurl}}" target="_blank">Link to file</a>
                    }
                    @if (pkg.fileurl==null) {
                      <p>--</p>
                    }
                  </div>
                  @if (permissions?.packagePermissions?._delete) {
                    <div class="delete-package-btn" (click)="deletePackage(pkg.id)">
                      <i class="material-icons" style="font-size: 16px">close</i>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
  @if (isExpanded) {
    <div class="fund-table">
      <table mat-table class="stripped-table" [dataSource]="paymentForms">
        <ng-container matColumnDef="fund">
          <th class="fund-table-header generate-button-header" style="padding-left: 10px; font-weight: 700" mat-header-cell *matHeaderCellDef>
            Payments
          </th>
          <td mat-cell *matCellDef="let row">
            @if (!row.value.warehouse) {
              {{row.value.fund!==null ? row.value.fund: row.value.certificatedOutlet}}
            }
            @if (row.value.warehouse) {
              Warehouse Line
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th class="fund-table-header" mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let row">
            @if (row.value.amount!==null && readOnly) {
              {{row.value.amount | currency: 'USD': 'symbol': '1.2-2'}}
            }
            @if (row.value.amount==null && readOnly) {
              --
            }
            @if (!readOnly) {
              <span>$</span>
              <input [formControl]="row.controls.amount" name="amount" type="text" currencyParser (wheel)="$event.preventDefault()">
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="adjuster">
          <th class="fund-table-header" mat-header-cell *matHeaderCellDef>Adjuster</th>
          <td mat-cell *matCellDef="let row">
            @if (row.value.adjuster!==null && readOnly) {
              {{row.value.adjuster | currency: 'USD': 'symbol': '1.2-2'}}
            }
            @if (row.value.adjuster==null && readOnly) {
              --
            }
            @if (!readOnly) {
              <span>$</span>
              <input [formControl]="row.controls.adjuster" name="adjuster" type="text" currencyParser (wheel)="$event.preventDefault()">
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th class="fund-table-header" mat-header-cell *matHeaderCellDef>
            <div class="row" style="justify-content: flex-end; align-items: center">
              <div class="col-md-3">
                @if (permissions?.paymentPermissions?._create && !readOnly) {
                  <button class="generate-payment-button" (click)="generateFundingPayments()">
                    Generate Payments
                  </button>
                }
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="row" style="justify-content: flex-end; padding-right: 0">
              @if (!readOnly) {
                <div class="action-container">
                  @if (permissions?.paymentPermissions?._delete) {
                    <div class="action-icon" (click)="openRemovePaymentModal(row)">
                      <i class="material-icons" style="font-size: 16px">close</i>
                    </div>
                  }
                </div>
              }
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="['fund', 'amount', 'adjuster', 'actions']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['fund', 'amount', 'adjuster', 'actions']"></tr>
      </table>
    </div>
  }
  @if (isExpanded) {
    <div class="row show-collapse" style="display: flex; justify-content: flex-end">
      <span class="site-hyperlink" (click)="toggleExpandAll()">Show/Collapse all</span>
    </div>
  }
  @if (isExpanded) {
    <div class="conditions-table">
      @if (conditions && conditions.length==0) {
<div class="row conditions-header" [ngClass]="{'due-highlight': true,
            'all-approved': false
            }">
          <div class="col-md-1">
            <div class="row">
              @if (!readOnly) {
                <div class="col-md-3">
                  @if (permissions?.conditionPermissions?._create) {
                    <button mat-mini-fab class="condition-add-button" (click)="openAddConditionModal()"><i class="material-icons" style="font-size: 16px">add</i></button>
                  }
                </div>
              }
              <div class="col-md-9">
                Condition Number
              </div>
            </div>
          </div>
          <div class="col-md-2">
            Condition Name
          </div>
          <div class="col-md-2">
            Nickname/Additional Notes
          </div>
          <div class="col-md-1">
            Status
          </div>
          <div class="col-md-1">
            Date
          </div>
          <div class="col-md-2">
            Notes
          </div>
          <div class="col-md-1">
          </div>
          <div class="col-md-1">
            Approvals
          </div>
        </div>
      }
      @if (conditions && conditions.length==0) {
        <div class="row no-conditions-row">
          No current conditions available
        </div>
      }
      @if (conditions && conditions.length>0) {
        <div>
          @for (condition of conditions; track condition; let i = $index; let even = $even) {
<!--            <div class="row conditions-header" [ngClass]="{'due-highlight': !allApproved(condition),-->
<!--            'am-approved-received-highlight': receivedAndAMApproved(condition),-->
<!--            'sr-ready-for-approval-highlight': readyForApprovalSrAM(condition),-->
<!--            'all-approved': allApproved(condition)-->
<!--            }">-->
              <div class="row conditions-header" [ngClass]="{'due-highlight': !allApproved(condition),
            'all-approved': allApproved(condition)
            }">
              <div class="col-md-1">
                <div class="row">
                  @if (!readOnly && i==0) {
                    <div class="col-md-3">
                      @if (permissions?.conditionPermissions?._create) {
                        <button mat-mini-fab class="condition-add-button" (click)="openAddConditionModal()"><i class="material-icons" style="font-size: 16px">add</i></button>
                      }
                    </div>
                  }
                  @if (readOnly || i!==0) {
                    <div class="col-md-9">
                    </div>
                  }
                  <div class="col-md-9">
                    Condition Number
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                Condition Name
              </div>
              <div class="col-md-2">
                Nickname/Additional Notes
              </div>
              <div class="col-md-1">
                Status
              </div>
              <div class="col-md-1">
                Date
              </div>
              <div class="col-md-2">
                Notes
              </div>
              <div class="col-md-1">
              </div>
              <div class="col-md-1">
                Approvals
              </div>
            </div>
            <equity-installment-conditions [condition]="condition" [conditionForm]="fetchConditionForm(condition)" [readonly]="readOnly" [isExpanded]="allConditionsExpanded" [highlight]="even" (save)="saveConditions()" (remove)="removeConditionForm($event)" [allApproved]="allApproved(condition)"></equity-installment-conditions>
          }
        </div>
      }
    </div>
  }
</div>
</ng-container>
